import React from 'react'
import Banner from '../components/Banner'
import TrendingMovies from './TrendingMovies'
function Movies() {
  
  return (
    <>
      <Banner/>
      <TrendingMovies/>      
    </>
  )
}

export default Movies
